export const ParseProductDimension = (productcode) => {
    const regex = /^[A-Za-z]+ [A-Za-z0-1]+ [a-zA-z0-1]+ \d+% (\d+) (\d+) (\d+\/?\d+)/;
    let m;
    if ((m = regex.exec(productcode)) !== null && !m[3].includes('/')) {
        return {
            width: Number(m[1]),
            height: Number(m[2]),
            depth: Number(m[3]),
        };
    }
    return null;
};


export const IsProductStandard = (product) => {
    // if product.productName starts with "VPF"/"PF", check the standardClass attriute
    if (
        product.productName &&
        (product.productName.toUpperCase().startsWith('VPF') || product.productName.toUpperCase().startsWith('PF'))
    ) {
        return product.standardClass !== 0;
    }
    // if not VPF product, return true
    return true;
};
